export const GUEST_TYPE_SINGLE_PERSON = 1;
export const GUEST_TYPE_FAMILY = 2;